import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'theme/withStyles';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';

const styles = ({ forms, palette, screenSizes, typography }) => ({
  liRoot: {
    lineHeight: 1,
    marginRight: 2,
    [`@media(min-width: ${screenSizes.mobileMax}px)`]: {
      flex: 1,
    },
    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      display: 'table-cell',
      minWidth: ({ progress }) =>
        progress.length > 4 ? screenSizes.mobileMax / progress.length + 20 : 206,
      paddingRight: 4,
      width: '100%',
    },
  },
  progressBarWrap: {
    '& div': {
      background: palette.progress.complete,
      height: 4,
      textIndent: -999999999,
    },
    background: palette.progress.inComplete,
    height: 2,
    [`@media(min-width: ${screenSizes.mobileMax}px)`]: {
      '& div': {
        position: 'relative',
        top: -1,
      },
    },
    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      '& div': {
        marginTop: -2,
      },
      paddingTop: 1,
    },
  },
  progressText: {
    ...typography.progress,
    display: 'inline-block',
    padding: [0, 0, 8],
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  root: {
    display: 'flex',
    flex: 1,
    width: forms.maxWidth,

    [`@media(max-width: ${screenSizes.mobileMax}px)`]: {
      display: 'table',
      flexWrap: 'nowrap',
      margin: [0, 'auto'],
      overflowY: 'hidden',
      padding: [0, 20, 10],
      tableLayout: 'fixed',
      width: 'auto',
    },

    [`@media(min-width: ${screenSizes.desktopLgMin}px)`]: {
      margin: '0 auto',
    },
  },
});

const Progress = ({ classes, progress }) => {
  if (!progress) {
    return null;
  }
  return (
    <ol className={classnames('progress-list-view', classes.root)}>
      {progress.map((p) => (
        <li key={p.group} className={classes.liRoot}>
          <RawHtml type="span" className={classes.progressText}>
            {p.group}
          </RawHtml>
          <div className={classnames('progress-bar-wrap', classes.progressBarWrap)}>
            <div
              style={{
                width: `${(parseFloat(p.current) / parseFloat(p.total)) * 100}%`,
              }}
            >
              {`${p.current}/${p.total}`}
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
};

Progress.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  progress: PropTypes.arrayOf(PropTypes.shape({})),
};

Progress.defaultProps = {
  progress: null,
};

export default withStyles(styles)(Progress);
